/*
 * Journal article interactivity.
 * Currently: .jn-hotspot — tappable + markers that reveal a feature popover.
 * Loaded on Journal articles via sections/journal-styles.liquid.
 */
(function () {
  function buildPopover() {
    var popover = document.createElement('div');
    popover.className = 'jn-hotspot__popover';
    popover.id = 'jn-hotspot-popover-' + Math.random().toString(36).slice(2, 8);
    popover.setAttribute('role', 'tooltip');
    popover.hidden = true;

    var titleEl = document.createElement('p');
    titleEl.className = 'jn-hotspot__popover-title';

    var textEl = document.createElement('p');
    textEl.className = 'jn-hotspot__popover-text';

    popover.appendChild(titleEl);
    popover.appendChild(textEl);

    return { popover: popover, titleEl: titleEl, textEl: textEl };
  }

  function initHotspot(hotspot) {
    var dots = hotspot.querySelectorAll('.jn-hotspot__dot');
    if (!dots.length) {
      return;
    }

    var parts = buildPopover();
    var popover = parts.popover;
    hotspot.appendChild(popover);

    var activeDot = null;

    function close() {
      if (!activeDot) {
        return;
      }
      popover.hidden = true;
      activeDot.setAttribute('aria-expanded', 'false');
      activeDot.removeAttribute('aria-describedby');
      activeDot = null;
    }

    function open(dot) {
      parts.titleEl.textContent = dot.getAttribute('data-title') || '';
      parts.textEl.textContent = dot.getAttribute('data-text') || '';
      popover.style.left = dot.style.left;
      popover.style.top = dot.style.top;
      popover.hidden = false;
      dot.setAttribute('aria-expanded', 'true');
      dot.setAttribute('aria-describedby', popover.id);
      activeDot = dot;
    }

    dots.forEach(function (dot) {
      dot.setAttribute('type', 'button');
      dot.setAttribute('aria-expanded', 'false');
      dot.addEventListener('click', function (evt) {
        if (activeDot === dot) {
          close();
        } else {
          close();
          open(dot);
        }
      });
    });

    document.addEventListener('click', function (evt) {
      if (activeDot && !popover.contains(evt.target) && !hotspot.contains(evt.target)) {
        close();
      }
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') {
        close();
      }
    });
  }

  function init() {
    document.querySelectorAll('.jn-hotspot').forEach(function (hotspot) {
      initHotspot(hotspot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
